import React from 'react';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import SarasTooltip from '../../../../../library/notifications/SarasTooltip';
import { getShowDocumentLink } from '../../../../../helper/uiFunctions';
import * as fn from '../../../../../helper/uiFunctions';

const ProdPlanPopupProcessData = ({ process }) => {
    const getStyle = () => {
        if (process?.taskStatusStyle && process.taskStatusStyle !== '') {
            try {
                return JSON.parse(process.taskStatusStyle);
            }
            catch
            {
                return {};
            }
        }

        return {};
    };

    if (!process) return null;

    const holdRowId = process?.holdRowId || 0;
    const holdStatus = process?.holdStatus || '';
    const holdStatusDays = process?.holdStatusDays || 0;
    const holdLabel = `On Hold: ${holdStatusDays}d`;

    const onOpenOutsource = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const outsourceLink = getShowDocumentLink(process.outsourceTypeId, process.outsourceId, '', 1, '', '');
        if (!outsourceLink) return;

        window.open(outsourceLink, '_blank');
    };

    const hasAllocatedTo = !!process.allocatedTo;
    const hasOutsource = Number(process.outsourceTypeId) > 0 && Number(process.outsourceId) > 0;

    return (
        <div className="uiProdGridProcessContainer">
            <div className="uiTitle">
                {process.taskTitleDisplay} <span style={getStyle()} className="uiChip">{process.taskStatus}</span>
                {
                    !fn.compareNumber(holdRowId, 0) ? (
                        <SarasTooltip title={
                            <>
                                <div><SarasTrans value='Reason' />: <SarasTrans value={holdStatus} /></div>
                                {
                                    !fn.compareNumber(holdStatusDays, 0)
                                    ? <div><SarasTrans value='Since' />: {holdStatusDays} <SarasTrans value='days' /></div>
                                    : null
                                }
                            </>
                        } tooltipAlign='bottom-start'>
                            <span className="uiChip uiChipRed">{holdLabel}</span>
                        </SarasTooltip>
                    ) : null
                }
            </div>
            {(hasAllocatedTo || hasOutsource) ? (
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
                    {hasAllocatedTo ? (
                        <span>{process.allocatedTo}</span>
                    ) : null}
                    {hasOutsource ? (
                        <button
                            type="button"
                            onClick={onOpenOutsource}
                            style={{
                                background: 'none',
                                border: 'none',
                                padding: 0,
                                color: '#2563eb',
                                cursor: 'pointer',
                                fontWeight: 600
                            }}
                        >
                            {process.outsourceId}
                        </button>
                    ) : null}
                </div>
            ) : null}
            <div>
                <span className="uiBold"><SarasTrans value="Iss" /></span>
                <span className="uiSpacerH5">{process.taskIssuedOn}</span>
                <span className="uiBold"><SarasTrans value="Ret" /></span>
                <span className="uiSpacerH5">{process.taskReturnedOn}</span>
            </div>
            <div>
                <span className="uiBold"><SarasTrans value="Hrs" /></span>
                <span className="uiSpacerH5">{process.taskEstTime}</span>
                <span> / </span>
                <span className="uiSpacerH5">{process.taskActTime}</span>
            </div>
        </div>
    );
};

export default ProdPlanPopupProcessData;
